export interface TokenClaims {
  oid: string;
  roles: string[];
  name: string;
  email: string;
}

/**
 * Décode (SANS vérifier) le payload d'un access token Entra pour l'affichage
 * client. La vérification réelle (signature/iss/aud/exp) est faite côté serveur
 * (kronos-api, jose). Le serveur fait autorité ; ceci n'est que pour l'UI.
 */
export function decodeClaims(accessToken: string): TokenClaims {
  const part = accessToken.split('.')[1] ?? '';
  let p: Record<string, unknown> = {};
  try {
    p = JSON.parse(atob(part));
  } catch {
    p = {};
  }
  const roles = Array.isArray(p.roles) ? (p.roles as unknown[]).filter((r): r is string => typeof r === 'string') : [];
  return {
    oid: String(p.oid ?? p.sub ?? ''),
    roles,
    name: String(p.name ?? p.preferred_username ?? ''),
    email: String(p.preferred_username ?? ''),
  };
}
